export const DEFAULT_SECRET = "better-auth-secret-12345678901234567890";
